/*
 * MySiteCare
 *
 * Copyright © 2026 Jeanjen Sisoy Luberio
 * doing business as MySiteCare Website Application Services.
 * All rights reserved.
 *
 * DTI Business Name No. 7934250
 * https://mysitecare.eu
 *
 * This file contains original proprietary MySiteCare source code,
 * except for third-party components identified under their
 * respective licenses.
 */
import { Link, Navigate, useLocation, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import StoreShell from "@/components/store/StoreShell";

function money(minor) { return `₱${((minor || 0) / 100).toLocaleString("en-PH", { minimumFractionDigits: 2 })}`; }

export default function StoreOrderConfirmation() {
  const { slug } = useParams();
  const { state } = useLocation();

  // No confirmation state means this page was opened directly (e.g. a reload) rather
  // than arriving right after a real checkout — send the shopper back rather than
  // showing a confirmation for an order we can't actually confirm here.
  if (!state) return <Navigate to={`/store/${slug}`} replace />;

  return (
    <StoreShell slug={slug}>
      <div className="rounded-2xl border border-[#E2E8F0] p-8 text-center" data-testid="order-confirmation">
        <CheckCircle2 className="mx-auto text-emerald-600" size={40} />
        <h1 className="mt-3 text-2xl font-bold font-display text-[#0F172A]">Order Confirmed</h1>
        <p className="mt-1 text-sm text-[#475569]">Order number: <strong>{state.order_number}</strong></p>

        <div className="mt-6 text-left">
          {state.items.map((item, i) => (
            <div key={i} className="flex justify-between text-sm py-1">
              <span>{item.product_name} × {item.quantity}</span><span>{money(item.line_total_minor)}</span>
            </div>
          ))}
          <div className="mt-2 flex justify-between border-t border-[#E2E8F0] pt-2 font-bold text-[#0F172A]"><span>Total</span><span>{money(state.total_minor)}</span></div>
        </div>

        <p className="mt-4 rounded-lg bg-[#F8FAFC] px-3 py-2 text-sm text-[#475569]">{state.payment_note}</p>
        <Link to={`/store/${slug}`} className="mt-5 inline-block text-sm font-medium text-[#10B981] hover:underline">Continue shopping</Link>
      </div>
    </StoreShell>
  );
}
